import { useCallback, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector, useAppStore } from 'store/hooks';
import { SellOrderType } from '../types';
import { selectIsInitialRequestingOrders, selectIsPaginationTokenForOrders, selectIsRequestingOrders, } from '../reducers/selectors';
import { getOrders } from '../actions';
const useOrders = (infoObj) => {
    const store = useAppStore();
    const dispatch = useAppDispatch();
    const shouldLoadSecondPage = useRef(false);
    const loading = useAppSelector((store) => selectIsRequestingOrders(store, infoObj));
    const initialRequesting = useAppSelector((store) => selectIsInitialRequestingOrders(store, infoObj));
    useEffect(() => {
        if (!initialRequesting) {
            if (infoObj.tradingAccountId) {
                dispatch(getOrders({
                    statuses: ['pending', 'queued'],
                    accountId: infoObj.tradingAccountId,
                    assetIds: infoObj.assetId ? [infoObj.assetId] : [],
                    orderTypes: infoObj.orderType === 'limitAndStop' ? [SellOrderType.LIMIT, SellOrderType.STOP] : [SellOrderType.MARKET],
                }));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [infoObj.assetId, infoObj.orderType]);
    const loadMoreData = useCallback(() => {
        const token = selectIsPaginationTokenForOrders(store.getState(), infoObj);
        if (token) {
            if (infoObj.tradingAccountId) {
                dispatch(getOrders({
                    statuses: ['pending', 'queued'],
                    accountId: infoObj.tradingAccountId,
                    assetIds: infoObj.assetId ? [infoObj.assetId] : [],
                    orderTypes: infoObj.orderType === 'limitAndStop' ? [SellOrderType.LIMIT, SellOrderType.STOP] : [SellOrderType.MARKET],
                    paging: { token },
                }));
            }
        }
    }, [infoObj]);
    const onLoadNextPage = useCallback(() => {
        if (loading) {
            shouldLoadSecondPage.current = true;
        }
        else {
            loadMoreData();
        }
    }, [loadMoreData, loading]);
    useEffect(() => {
        if (!loading && shouldLoadSecondPage.current) {
            shouldLoadSecondPage.current = false;
            loadMoreData();
        }
    }, [loadMoreData, loading]);
    return [loading, initialRequesting, onLoadNextPage];
};
export default useOrders;
